import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/mart-sales', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/mart-sales/delete/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const category = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchSystemSettings = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/system-settings', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchCompanyInfo = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/company-infos', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchPromotions = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/promotions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getOrderHistory = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/order-histories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const printPDF = data => {
  return httpClient
    .post('/api/v1/mart-sales/generate-pdf', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const sysQty = productId => {
  return httpClient
    .get(`/api/v1/mart-sales/${productId}/products`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const paymentMethod = (Option = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/payment-methods', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const bankProfile = () => {
  return httpClient
    .get('/api/v1/mart-sales/bank-profiles')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/mart-sales/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy,
  category,
  fetchSystemSettings,
  product,
  fetchCompanyInfo,
  fetchPromotions,
  getOrderHistory,
  printPDF,
  sysQty,
  paymentMethod,
  bankProfile,
  formViewModel
}
